import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface OrientationShiftPillProps {
  size?: PillSize;
  variant?: PillVariant;
  compact?: boolean;
}

export function OrientationShiftPill(props: OrientationShiftPillProps) {
  const { size = "small", variant = "filled", compact = false } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label={compact ? undefined : "Orientation"}
      iconType="compass-filled"
      backgroundColor={(theme) => theme.palette.intent?.success.background}
      color={(theme) => theme.palette.intent?.success.text}
      iconColor={(theme) => theme.palette.intent?.success.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
